import React from 'react'
import { useTranslation } from '@mc/i18n'
import { Truncate } from './Truncate'

interface DescriptionProps {
  description: string
  textClassName?: string
}

export const Description = ({
  description,
  textClassName = '',
}: DescriptionProps) => {
  const { t } = useTranslation('@mc/next')

  const truncateProps = {
    text: description,
    textStyle: textClassName,
    showMoreText: t('sessions.campHero.descriptionShowMore'),
    showLessText: t('sessions.campHero.descriptionShowLess'),
  }

  return (
    <div className='row'>
      <div className='col-12'>
        <div className='d-block d-md-none'>
          <Truncate maxLine={2} {...truncateProps} />
        </div>
        <div className='d-none d-md-block'>
          <Truncate maxLine={3} {...truncateProps} />
        </div>
      </div>
    </div>
  )
}
